export default __webpack_public_path__ + "static/media/icon_edit.2fd44da2.svg";